/**
 * Camera configuration constants for different camera modes.
 * Centralized configuration makes it easier to tune camera behavior.
 */

export const CAMERA_CONFIG = {
  /** First-person camera settings */
  firstPerson: {
    /** Eye height above the floor in meters */
    eyeHeight: 1.6,
    /** Clearance from ceiling to prevent clipping */
    ceilingClearance: 0.3,
    /** Minimum distance camera can zoom in */
    minDistance: 0.5,
    /** Maximum distance camera can zoom out */
    maxDistance: 10,
  },

  /** Third-person camera settings */
  thirdPerson: {
    /** Human eye height above the floor in meters */
    eyeHeight: 1.7,
    /** Horizontal offset from the center (how far back from the scene) */
    horizontalOffset: 3.0,
    /** Downward viewing angle in radians (looking slightly down) */
    lookDownAngle: Math.PI / 8, // 22.5 degrees
    /** Minimum distance camera can zoom in */
    minZoomDistance: 1.5,
    /** Maximum distance camera can zoom out */
    maxZoomDistance: 15,
  },

  /** Top-down camera settings */
  topDown: {
    /** Multiplier for distance above scene based on scene size */
    distanceMultiplier: 1.5,
    /** Minimum distance above scene */
    minDistance: 10,
    /** Minimum distance camera can zoom in */
    minZoomDistance: 2,
    /** Maximum distance camera can zoom out */
    maxZoomDistance: 50,
  },
} as const;
